import React, { useEffect, useMemo } from 'react';
import { useField } from 'react-final-form';
import { observer } from 'mobx-react';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';
import { TextAreaField } from 'ksnm-common-ui/lib/Form/TextAreaField';

import { fetchReferences } from '@stores/dictionaryStores/fetchReferences';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';
import { reportPeriodsStore } from '@stores/dictionaryStores/reportPeriodsStore';
import { reportEditStore } from '@stores/dictionaryStores/reports/reportEditStore';
import { reportTypesStore } from '@stores/dictionaryStores/reportTypes';

export const ReportForm = observer(() => {
  const { isNew, isEditMode, setDisableEdit } = reportEditStore;
  const { reportGroups } = reportGroupsStore;
  const { reportTypes } = reportTypesStore;
  const { groupInPeriods } = reportPeriodsStore;

  useEffect(() => {
    fetchReferences(['reports', 'reportGroups', 'reportTypes', 'reportPeriods']);
  }, []);

  const {
    input: { value: regulated },
  } = useField('regulated');

  useEffect(() => {
    if (regulated) setDisableEdit();

    return () => setDisableEdit(false);
  }, [regulated, setDisableEdit]);

  // отображаем только те группы, по которым есть настройка в Календаре отчетных форм
  const reportGroupItems = useMemo(
    () => reportGroups.filter((item) => groupInPeriods.includes(item.code)),
    [groupInPeriods, reportGroups],
  );

  return (
    <>
      <SelectField
        items={reportGroupItems}
        name="reportGroupCode"
        label="Код группы отчетных форм"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        renderName={(value) => `${value.code} - ${value.name}`}
        allowClear
        required
      />
      <SelectField
        items={reportTypes}
        name="reportTypeCode"
        label="Тип отчета"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        required
        renderName={(value) => `${value.code} - ${value.name}`}
      />
      <TextField
        name="code"
        label="Код отчета"
        disabled={!isNew}
        size="small"
        groupStyle={!isEditMode}
        maxLength={30}
        required
      />
      <TextField
        name="codeExt"
        label="Внешний код отчета"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        maxLength={50}
        required
      />

      <TextField
        name="name"
        label="Наименование отчета"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        maxLength={255}
        required
      />
      <TextAreaField
        rows={1}
        name="description"
        label="Описание"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        maxLength={500}
        autoSize
      />
    </>
  );
});
